"use client";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";

const RequestSignConfirmModal = ({
  isOpen,
  onConfirm,
  onClose,
}: {
  isOpen: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}) => {
  const onClick = async () => {
    await onConfirm();
  };

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Modal isOpen={isOpen} onClose={() => {}}>
      <div className="flex flex-col items-center px-8 pb-5 pt-[30px] text-center ">
        <p className="mb-4 text-[19.2px]">契約書の確認と押印を依頼しますか？</p>
        <p className="text-16px">契約書の内容をご確認の上、</p>
        <p className="text-16px">依頼してください</p>
        <p className="text-s font-bold text-[#EE8F00]">※依頼は一回のみとなります</p>
        <div className="mt-[39px] flex gap-4">
          <Button text="キャンセル" onClick={onClose} style={ButtonStyle.OUTLINE} width="w-[160px]" />
          <Button text="依頼する" onClick={onClick} style={ButtonStyle.PRIMARY} width="w-[160px]" />
        </div>
      </div>
    </Modal>
  );
};

RequestSignConfirmModal.displayName = "CompleteRequestSignConfirmModalConfirmModal";

export default RequestSignConfirmModal;
